import { getDataMapper, mapField } from "@/shared";

export const mapSalariesHistoryFiltersToServer = getDataMapper({
    startDate: mapField("period", (item) => item.from),
    endDate: mapField("period", (item) => item.to),
    fio: mapField("employee", (item) => item.human.fio),
});
